/**
 * Pragmatic syntax check for marketing funnels: catches garbage without
 * rejecting real addresses. The TLD is deliberately `{2,}` — TLDs like
 * ".email" or ".online" are longer than 4 characters, and each domain label
 * must be non-empty (no "a@b..com") and not start/end with a hyphen.
 */
const EMAIL_REGEX =
  /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

export function validateEmail(email: string): boolean {
  const value = email.trim();
  return value.length <= 254 && EMAIL_REGEX.test(value);
}

/**
 * Emails never contain whitespace; strip it as the user types so mobile
 * keyboards' auto-inserted spaces can't produce an invalid stored value.
 */
export function sanitizeEmailInput(value: string): string {
  return value.replace(/\s+/g, "");
}
